function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from "react";
import cx from "classnames";
import { ImageContext, LinkContext } from "../../../context";
import { twMerge } from "../../../utils";
import { CallToAction, Heading, Subheading } from "../../atoms";
import { ArrowRight } from "../../icons";
export var NewsGridCard = function(param) {
    var labels = param.labels, title = param.title, image = param.image, callToAction = param.callToAction, className = param.className;
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var LinkComponent = useContext(LinkContext).LinkComponent;
    var _sizes;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge(cx("flex", className))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full grid grid-cols-1 grid-rows-[auto_minmax(0,1fr)] gap-5 md:gap-7"
    }, /*#__PURE__*/ React.createElement(LinkComponent, _extends({}, callToAction, {
        className: "block"
    }), /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, image, {
        sizes: (_sizes = image.sizes) !== null && _sizes !== void 0 ? _sizes : "(min-width: 48em) 35vw, 100vw",
        className: "block w-full h-[12.5rem] object-cover object-center pointer-events-none"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-between"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-5 md:gap-6"
    }, !!(labels === null || labels === void 0 ? void 0 : labels.length) && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-start items-center flex-wrap -m-2"
    }, labels.map(function(_param) /*#__PURE__*/ {
        var label = _param.label, linkProps = _objectWithoutProperties(_param, [
            "label"
        ]);
        return React.createElement(LinkComponent, _extends({
            key: label
        }, linkProps), /*#__PURE__*/ React.createElement(Subheading, {
            className: "m-2"
        }, label));
    }))), /*#__PURE__*/ React.createElement(LinkComponent, _extends({}, callToAction, {
        className: "block"
    }), /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title))), /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement(CallToAction, _extends({}, callToAction, {
        style: "link",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
        className: "mt-9"
    }))))));
};

//# sourceMappingURL=NewsGridCard.js.map